import { useLayoutEffect } from 'react';
import useNetwork from '../../v2/hooks/useNetwork';
import useAppErrorDispatcher from './useAppErrorDispatcher';

const useNetworkErrorHandler = (): void => {
  const { isOnline } = useNetwork();
  const { dispatch, reset } = useAppErrorDispatcher();

  useLayoutEffect(() => {
    if (!isOnline) {
      dispatch('applicationOffline');
    } else {
      reset('applicationOffline');
    }
  }, [isOnline, reset, dispatch]);
};

export default useNetworkErrorHandler;
